import React from 'react';

export const GlassCard: React.FC<{
  accentColor: string;
  children: React.ReactNode;
  padding?: number;
  width?: number;
}> = ({accentColor, children, padding = 28, width}) => (
  <div
    style={{
      width,
      borderRadius: 44,
      padding,
      background:
        'linear-gradient(135deg, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0.05) 28%, rgba(0,0,0,0.22) 100%)',
      border: '1.5px solid rgba(255,255,255,0.16)',
      boxShadow: `0 22px 60px rgba(0,0,0,0.35), 0 0 60px ${accentColor}22`,
      backdropFilter: 'blur(18px)',
      WebkitBackdropFilter: 'blur(18px)',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: `linear-gradient(135deg, rgba(255,255,255,0.10) 0%, ${accentColor}0A 34%, transparent 100%)`,
        pointerEvents: 'none',
      }}
    />
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 90,
        background:
          'linear-gradient(180deg, rgba(255,255,255,0.12) 0%, transparent 100%)',
        pointerEvents: 'none',
      }}
    />
    <div style={{position: 'relative'}}>{children}</div>
  </div>
);
